(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-cwt-collection-search]').forEach((form) => {
      if (form.dataset.collectionSearchReady === 'true') {
        return;
      }

      form.dataset.collectionSearchReady = 'true';

      const input = form.querySelector('input[name="q"]');
      const reset = form.querySelector('.cwt-shop-search__reset');
      const allProductsLink = form.closest('.cwt-collection-hero')?.querySelector('[data-cwt-search-all-products]');
      const toolbar = document.querySelector('.cwt-collection-toolbar');
      const activeFilters = document.querySelector('.cwt-collection-active-filters');
      const countWrapper = document.querySelector('.cwt-collection-toolbar__controls .products-count-wrapper span');
      const productItems = Array.from(document.querySelectorAll('.cwt-collection-products .product-grid__item'));
      const collectionUrl = form.dataset.collectionUrl || window.location.pathname;
      const params = new URLSearchParams(window.location.search);
      const initialQuery = (params.get('q') || '').trim();

      function updateAllProductsLink(query) {
        if (!allProductsLink) return;

        allProductsLink.href = query
          ? `/search?type=product&q=${encodeURIComponent(query)}`
          : '/search?type=product&q=';
      }

      function matchesItem(item, query) {
        if (!query) return true;
        return (item.textContent || '').toLowerCase().includes(query.toLowerCase());
      }

      function applyCollectionSearch(query) {
        let visibleCount = 0;

        productItems.forEach((item) => {
          const isVisible = matchesItem(item, query);
          item.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        if (countWrapper && query) {
          countWrapper.textContent = `${visibleCount} shown`;
        }

        if (activeFilters && query) {
          activeFilters.innerHTML = `<span class="cwt-collection-chip cwt-collection-chip--query">Search: ${query.replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char])}<span aria-hidden="true">×</span></span>`;
        }

        updateAllProductsLink(query);
      }

      if (input && initialQuery) {
        input.value = initialQuery;
        if (reset) reset.hidden = false;
        applyCollectionSearch(initialQuery);
      } else {
        updateAllProductsLink('');
      }

      form.addEventListener('submit', (event) => {
        event.preventDefault();

        if (!input) return;

        const query = input.value.trim();
        const nextUrl = new URL(collectionUrl, window.location.origin);

        if (query) {
          nextUrl.searchParams.set('q', query);
        }

        window.location.href = nextUrl.toString();
      });

      if (input) {
        input.addEventListener('input', () => {
          updateAllProductsLink(input.value.trim());
        });
      }

      if (reset && input) {
        reset.addEventListener('click', () => {
          const current = new URL(window.location.href);
          if (current.searchParams.has('q')) {
            current.searchParams.delete('q');
            window.location.href = current.toString();
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
